import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import toast, { Toaster } from 'react-hot-toast';
import { MdClear } from "react-icons/md";
import Select from 'react-select';
import * as Constants from '../../constants';
import HabitacionService from '../../services/habitacion.service';
import { AuthenticationService } from '../../services/authentication.service';
import './NuevaHabitacion.css';

const PopUpHabitacion = (props) => {
	const [t] = useTranslation("global");

	const [planta, setPlanta] = useState('');
	const [edificio, setEdificio] = useState('');
	const [numero, setNumero] = useState('');
	const [estadoHabitacion, setEstadoHabitacion] = useState('');
	const [activo, setActivo] = useState('');
	var [esValido, setValido] = useState(true);

	const [selectedHabitacion, setSelectedHabitacion] = useState(null);
	const [listaEstadosHabitacion, setListaEstadosHabitacion] = useState([]);

	const [identificadorError, setIdentificadorError] = useState('')
	const [numeroError, setNumeroError] = useState('');
	const [edificioError, setEdificioError] = useState('');
	const [plantaError, setPlantaError] = useState('');
	const [estadoHabitacionError, setEstadoHabitacionError] = useState(null)
	const [combinarCamas, setCombinarCamas] = useState(false);
	const toastGenericErrorLogin = () => toast.error(t('app.error.login.generic'));
	
	const authenticationService = new AuthenticationService();
	const userRol = authenticationService.getAuthenticationSession().user.idTipo;
	const tipoEmpleado = authenticationService.getAuthenticationSession().user.tipoEmpleado;//obtiene el tipo de trabajador

	useEffect(() => {
		props.loadEstados();
		obtenerEstadoHabitaciones();
		setSelectedHabitacion(props.selectedHabitacion);

		if (props.selectedHabitacion != null) {
			// Modo edicion
			setEdificio(props.selectedHabitacion.edificio);
			setPlanta(props.selectedHabitacion.planta);
			setNumero(props.selectedHabitacion.numero);
			setEstadoHabitacion(props.selectedHabitacion.estadoHabitacion)
			setActivo(props.selectedHabitacion.activo);
			setCombinarCamas(!!props.selectedHabitacion.combinarCamas);

		}

	}, []);

	function handleLogin(e) {
		e.preventDefault()
		// Code to handle login goes here
		
		if(esValido) {
			props.toggle()
		}
		
	}


	const obtenerEstadoHabitaciones = async () => {
		await HabitacionService.getEstadosHabitacion()
			.then(response => response.json())
			.then(data => setListaEstadosHabitacion(data));

	}

	function validateForm(habitacion) {

		// Set initial error values to empty  
		setEdificioError('')
		setPlantaError('')
		setNumeroError('')
		setEstadoHabitacionError(null)

		if (habitacion.edificio === '') {
			setEdificioError(t('app.error.campoObligatorio'))
			setValido(false);
			return;
		}

		if (habitacion.planta === '') {
			setPlantaError(t('app.error.campoObligatorio'))
			setValido(false);
			return;
		}

		if (habitacion.numero === '') {
			setNumeroError(t('app.error.campoObligatorio'))
			setValido(false);
			return;
		}
		
		if (habitacion.estadoHabitacion === '') {
			setEstadoHabitacionError(t('app.error.campoObligatorio'))
			setValido(false);
			return;
		}


		if (habitacion.id != null) {
			updateHabitacion(habitacion)
		} else {
			insertHabitacion(habitacion);
		}
	}


	const guardarHabitacion = async () => {

		if (selectedHabitacion != null) {
			editarHabitacion(selectedHabitacion);
		} else {
			crearHabitacion();
		}

	}
	
	const marcarNoTerminadaHabitacion = async () => {

		if (selectedHabitacion != null) {
			updateNoTerminadaHabitacion(selectedHabitacion.id);
		
		}

	}

	const crearHabitacion = async () => {

		const habitacion = {

			establecimiento: props.selectedEstablecimiento,
			edificio: edificio,
			planta: planta,
			numero: numero,
			activo: true,
			estadoHabitacion: estadoHabitacion
		};
		validateForm(habitacion);
	}


	const editarHabitacion = async (selectedHabitacion) => {

		const habitacion = {
			id: selectedHabitacion.id,
			establecimiento: props.selectedEstablecimiento,
			edificio: edificio,
			planta: planta,
			numero: numero,
			activo: activo,
			estadoHabitacion: estadoHabitacion,
			combinarCamas: combinarCamas

		};

		validateForm(habitacion);
	}

	const insertHabitacion = async (habitacion) => {
		await HabitacionService.crearHabitacion(habitacion)
			.then((response) => {
				if (response.status === 200) {

					// Close popup on insert success
					props.toggle();

					// Refresh table
					props.limpiarFiltros();
					props.loadHabitaciones();

				} else {
					toastGenericErrorLogin();
				}
			})
			.catch((err) => {
				toastGenericErrorLogin();
			});
	}

	const updateHabitacion = async (habitacion) => {
		await HabitacionService.actualizarHabitacion(habitacion)
			.then((response) => {
				if (response.status === 200) {

					// Close popup on insert success
					props.toggle();

					// Refresh table

					props.limpiarFiltros();
					props.loadHabitaciones();

				} else {
					toastGenericErrorLogin();
				}
			})
			.catch((err) => {
				toastGenericErrorLogin();
			});;
	}
	
	
	const updateNoTerminadaHabitacion = async (id) => {
		await HabitacionService.marcarNoTerminada(id)
			.then((response) => {
				if (response.status === 200) {

					// Close popup on insert success
					props.toggle();

					// Refresh table

					props.limpiarFiltros();
					props.loadHabitaciones();

				} else {
					toastGenericErrorLogin();
				}
			})
			.catch((err) => {
				toastGenericErrorLogin();
			});;
	}

	const cancelarHabitacion = () => {

		// Close popup
		props.toggle();
	}

	const onChangeEstadoHabitacion = (ev) => {
		setEstadoHabitacion(ev)
	}
	
	const colorFiltros = {
	  menuList: styles => ({
	    ...styles,
	    background: '#FAE6F1',
	  }),
	  option: (styles, { isFocused, isSelected }) => ({
	    ...styles,
	    background: isSelected
	        ? '#91005F'
	        : '#FAE6F1',
	    zIndex: 1,
	    "&:hover": {
			background: 'rgba(145, 0, 95, 0.2)',
			color: '#000'
		},
	  }),
	  menu: base => ({
	    ...base,
	    zIndex: 100
	  }),
}

	// Para mostrar el color de fondo de la opción elegida en la lista de Estados de una habitación en Popup
	const getOptionValueEstadoHabitacion = option => option.id;


	return (
		<div className="popup">
			<div className="popup-inner">
				<div className="popup-Header">
					{selectedHabitacion != null ? <h1 className={"popup-Title"}>{t("app.habitacion.edicionHabitacion")}</h1> : <h1 className={"popup-Title"}>{t("app.habitacion.nuevaHabitacion")}</h1>}
					<button className="popup-btn-x" onClick={props.toggle}><MdClear /></button>
				</div>

				<div className="popup-Content">
					<form className="form-nuevaCama" onSubmit={handleLogin}>
						<div className="popup-div-inputs-popup">
							
							{(userRol === Constants.ROLE_USUARIO_TRABAJADOR && tipoEmpleado != null && tipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) ? 
								null
							 : (
								<div className={'inputAndSelectContainerPopup'}>
									<input placeholder={t("Edificio")} type="text" value={edificio} onChange={e => setEdificio(e.target.value)} />
									<label className="errorLabel">{edificioError}</label>
								</div>
							   )
							}
							
							{(userRol === Constants.ROLE_USUARIO_TRABAJADOR && tipoEmpleado != null && tipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) ? 
								null
							: (
								<div className={'inputAndSelectContainerPopup'}>
									<input placeholder={t("Planta")} type="text" value={planta} onChange={e => setPlanta(e.target.value)} />
									<label className="errorLabel">{plantaError}</label>
								</div>
								)
							}
							
							{(userRol === Constants.ROLE_USUARIO_TRABAJADOR && tipoEmpleado != null && tipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) ? 
								null
							: (
								<div className={'inputAndSelectContainerPopup'}>
									<input placeholder={t("Numero Habitacion")} type="text" value={numero} onChange={e => setNumero(e.target.value)} />
									<label className="errorLabel">{numeroError}</label>
								</div>
								)
							}

							<div className={'inputAndSelectContainerPopup'}>
								<Select
									className="selectPopupStyle"
									placeholder={t("app.poup.label.seleccionarEstadoHabitacion")}
									value={listaEstadosHabitacion.find(e => e.id === estadoHabitacion.id)}
									onChange={onChangeEstadoHabitacion}
									options={listaEstadosHabitacion}
									isSearchable={false}
									formatOptionLabel={estado => (
										<div>
											<span>{estado.estado}</span>
										</div>
									)}
									styles={colorFiltros}
									getOptionValue={getOptionValueEstadoHabitacion}
								/>
								<label className="errorLabel">{estadoHabitacionError}</label>
								
								{(userRol === Constants.ROLE_USUARIO_TRABAJADOR && tipoEmpleado != null && tipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) ? 
									null
								: (
									selectedHabitacion != null ? (
										<>
										 
										  
										  <div className={'checkboxContainerHabitacionPopup'}>
										    <label>{t("app.popup.label.activo")}</label>
										    <input type='checkbox' id='checkboxActivo' checked={activo} onChange={e => setActivo(e.target.checked)}/>
										  </div>

										</>
									) : null
								  )
								}
								

							</div>
							
							<div className={'checkboxContainerHabitacionPopup'}>
								<label>{t("app.popup.label.combinarCamas")}</label>
								<input type='checkbox' id='checkboxCombinarCamas' checked={combinarCamas} onChange={e => setCombinarCamas(e.target.checked)} />
							</div>
								
							<div className="popup-div-buttons">
								<button type="button" className="btn-general-colorPink" onClick={cancelarHabitacion}>{t("app.label.cancelar")}</button>
								<button type="submit" className="btn-general" onClick={guardarHabitacion}>{t("app.label.guardar")}</button>
								{(userRol === Constants.ROLE_USUARIO_TRABAJADOR && tipoEmpleado != null && tipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) ? 
									(
									selectedHabitacion != null ? (
										<button type="submit" className="btn-general" onClick={marcarNoTerminadaHabitacion}>{t("app.label.marcarnoterminada")}</button>
									) : null
								  )
								: null
								}
								
								<Toaster />
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}

export default PopUpHabitacion;







